export default __webpack_public_path__ + "static/media/P-038.a2193f0e.png";